import { EcEnv } from '@castlery/config';
import Script from 'next/script';

const CXEnv = EcEnv.NEXT_PUBLIC_APPLICATION_TEST_TAG ? 'STAGING' : 'PROD';

const embedSidekickUrl = () => {
  return CXEnv === 'STAGING'
    ? 'https://crxcase-cdn-test.castlery.com/casa/sdk.js'
    : 'https://crxcase-cdn-prod.castlery.com/casa/sdk.js';
};

interface CasaLoadScriptProps {
  handleOnLoad?: () => void;
  handleOnReady?: () => void;
  handleOnError?: () => void;
}

const CasaLoadScript = ({ handleOnLoad, handleOnReady, handleOnError }: CasaLoadScriptProps) => {
  return (
    <Script
      onLoad={() => {
        handleOnLoad?.();
      }}
      onReady={() => {
        handleOnReady?.();
      }}
      onError={() => {
        handleOnError?.();
      }}
      id="casa-script"
      src={embedSidekickUrl()}
      strategy="afterInteractive"
    />
  );
};

export { CasaLoadScript };
